<div class="error_screen">
  <h1 class="logo_dgb"> {{ 'COMMON.LABEL.CALL' | translate }} (855)23-999-990</h1>
  <div class="box_pop">
    <h1> {{ 'COMMON.LABEL.SORRY' | translate }} , </h1>
    <p class="main_description"> {{ 'GNB2400.LABEL.WE_CAN_T_SEEM_TO_FIND_THE_PAGE_YOU_RE_LOOKING_FOR' | translate }} </p>
    <p class="description"> {{ 'GNB2400.LABEL.THE_PAGE_YOU_RE_LOOKING_FOR_MIGHT_HAVE_BEEN_REMOVED_HAD_ITS_NAME_CHANGED' | translate }} </p>
    <p class="error_code"> {{ 'GNB2400.LABEL.ERROR_CODE_XX' | translate }} </p>
    <div class="wrap_btn center">
      <button type="button" class="btn02" (click)="onGoHome()"> {{ 'COMMON.BUTTON.GO_TO_HOME' | translate }} </button>
      <button type="button" class="btn01" (click)="onGoBack()"> {{ 'COMMON.BUTTON.GO_BACK' | translate }} </button>
    </div>
  </div>
</div>